import MDivider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import MTab from "@mui/material/Tab";
import MTabs from "@mui/material/Tabs";

const Divider = styled(MDivider)(() => ({
  marginLeft: "-24px",
  marginRight: "-24px",
}));

const Tab = styled(MTab)(() => ({
  // color: "#1D2939",
}));

const Tabs = styled(MTabs)(() => ({
  flex: 1,
}));

const TabsContainer = styled("div")(() => ({
  display: "flex",
}));

export { Divider, Tab, Tabs, TabsContainer };
